import { HorizontalBar } from 'vue-chartjs';
import merge from 'deepmerge';

export default {
  extends: HorizontalBar,
  props: ['chartData', 'options', 'numberOfResponses'],

  computed: {
    barOptions() {
      return merge.all([this.options || {}, {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            stacked: true,
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: `${this.numberOfResponses} Responses`,
            },
            ticks: {
              min: 0,
              max: 100,
              callback(value) {
                return `${value}%`;
              },
            },
            stacked: true,
          }],
        },
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              const dataset = data.datasets[tooltipItems.datasetIndex];
              // eslint-disable-next-line max-len
              return `${dataset.label}: ${tooltipItems.xLabel}% (${Math.round((dataset.numberOfResponses / 100) * tooltipItems.xLabel)})`;
            },
          },
        },
      }]);
    },
  },

  mounted() {
    this.renderChart(this.chartData, this.barOptions);
  },
};
